import React from "react";
import { AccountInfoContent } from "./AccountInfoContent";
import { Group } from "types/Models/group";

export const AccountInfoTabView = ({ group }: { group?: Group }) => {
  if (!group) {
    return null;
  }
  return (
    <div className="t-p-5 t-pt-0">
      <AccountInfoContent group={group} />
    </div>
  );
};
